const PHONE_REGEX = /^(\d{3})(\d{3})(\d{4})$/

function maskPhoneNumber(input) {
  const match = input.value.replace(/\D/g, '').match(PHONE_REGEX)

  if (match) {
    input.value = `${match[1]}-${match[2]}-${match[3]}`
  }
}

function bind(element, _instance) {
  maskPhoneNumber(element)
  element.addEventListener('input', () => maskPhoneNumber(element))
}

const PhoneNumber = {
  mounted() {
    bind(this.el, this)
  },
  updated() {
    maskPhoneNumber(this.el)
  },
}

export default {
  bind,
  hook: PhoneNumber,
}
